import { useForm, FormProvider } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { TransitionDuration } from 'library/constants/styles-config';
import { useEffect } from 'react';
import Header from '../header';
import {
  Container,
  FooterContainer,
  CancelButton,
  ConfirmButton,
} from '../styles';

const withFormContainer = (WrappedComponent) => (
  function WithModalContainer({
    autocomplete = undefined,
    isLoading = false,
    isOpened,
    isCancelDisplayed = true,
    validation,
    defaultValues = {},
    onClose,
    onSubmit,
    title,
    cancelText = 'Cancel',
    submitText = 'Submit',
    submitSecondText,
    contrastingFooter = false,
    footer = true,
    isThirdFooterButton = false,
    shouldUnregister = true,
    submitWidth,
    cancelWidth,
    customButton = null,
    ...props
  }) {
    const methods = useForm({
      resolver: yupResolver(validation),
      mode: 'onChange',
      defaultValues,
      shouldUnregister,
    });
    const handleSubmit = methods.handleSubmit(onSubmit);

    useEffect(() => {
      document.addEventListener('keyup', (e) => {
        if (e.key === 'Escape') onClose();
      });
    }, []);

    return (
      <Container
        isOpen={isOpened}
        overlayClassName="Overlay"
        shouldFocusAfterRender={false}
        closeTimeoutMS={TransitionDuration}
        width="720px"
      >
        <Header
          title={title}
          onClose={onClose}
        />
        <FormProvider {...methods}>
          <form onSubmit={handleSubmit} autoComplete={autocomplete}>
            <WrappedComponent {...props} isLoading={isLoading} defaultValues={defaultValues} />
            {customButton}
            <FooterContainer
              footer={footer}
              contrasting={contrastingFooter}
            >
              {/* eslint-disable-next-line max-len */}
              {isCancelDisplayed ? <CancelButton onClick={onClose} cancelWidth={cancelWidth} type="button">{cancelText}</CancelButton> : null}
              <ConfirmButton type="submit" disabled={!methods.formState.isValid || isLoading} submitWidth={submitWidth} aria-label={submitText}>
                <span>
                  {submitText}
                </span>
              </ConfirmButton>
              {isThirdFooterButton
                ? <ConfirmButton submitWidth="406px" aria-label={submitSecondText}>{submitSecondText}</ConfirmButton>
                : null}
            </FooterContainer>
          </form>
        </FormProvider>
      </Container>
    );
  }
);

export default withFormContainer;
